import { useCallback, useEffect, useState } from "react";
import { Box, List, Stack } from "@mui/joy";
import dayjs from "dayjs";
import { generateThoughtRecordKey } from "logic/logics";
import * as _ from "lodash";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { layoutAtom } from "recoil/layoutAtom";
import {
  thoughtRecordApi,
  ThoughtRecordType,
  THOUGHTRECORD_DOMAIN,
  THOUGHTRECORD_LIST_ENDPOINT,
} from "api/thoughtRecordApi";
import { patientAtom } from "recoil/patientAtom";
import { useQuery } from "@tanstack/react-query";
import ThoughtRecordListItem from "./ThoughtRecordListItem";
import AddNewThoughtRecordButton from "./AddNewThoughtRecordButton";
import ThoughtRecordFilter from "./ThoughtRecordFilter";
import { isDev } from "config";

export default function ThoughtRecordList({
  thoughtRecordList,
  setThoughtRecordList,
  setIsEmpty,
  currentThoughtRecord,
  setCurrentThoughtRecord,
  hasAiCommentTrkList,
  setHasAiCommentTrkList,
}: {
  thoughtRecordList?: ThoughtRecordType[];
  setThoughtRecordList: React.Dispatch<
    React.SetStateAction<ThoughtRecordType[] | undefined>
  >;
  setIsEmpty: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  currentThoughtRecord?: ThoughtRecordType;
  setCurrentThoughtRecord: React.Dispatch<
    React.SetStateAction<ThoughtRecordType | undefined>
  >;
  hasAiCommentTrkList: string[];
  setHasAiCommentTrkList: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  const user = useRecoilValue(userAtom);
  const isCoach = user?.role !== "patient";
  const { isTaskContainerSmall } = useRecoilValue(layoutAtom);
  const [listData, setListData] = useState<ThoughtRecordType[] | undefined>(
    thoughtRecordList
  );
  useEffect(() => {
    setListData(thoughtRecordList);
  }, [thoughtRecordList]);

  const [filterList, setFilterList] = useState<string[]>([
    "회사에서 협업할 때",
    "친구들이 장난 칠 때",
    "c",
  ]);
  const [selectedFilterList, setSelectedFilterList] = useState<string[]>([]);

  const patientState = useRecoilValue(patientAtom);

  useEffect(() => {
    if (hasAiCommentTrkList && hasAiCommentTrkList.length > 0) {
      setListData((listData) =>
        (listData || []).map((each) => ({
          ...each,
          hasAiRecommendation: hasAiCommentTrkList.includes(
            each.thoughtRecordKey
          ),
        }))
      );
    }
  }, [hasAiCommentTrkList]);

  // const queryFn = useCallback(
  //   () => thoughtRecordApi.getList(`${patientState?.patientId}`),
  //   [patientState]
  // );

  // const { refetch: getThoughtRecordList } = useQuery(
  //   [THOUGHTRECORD_DOMAIN, THOUGHTRECORD_LIST_ENDPOINT],
  //   queryFn,
  //   {
  //     enabled: true,
  //     onSuccess: (data) => {
  //       setThoughtRecordList(data.result);
  //       if (!data.result || data.result.length === 0) {
  //         setIsEmpty(true);
  //         if (!currentThoughtRecord) {
  //           setCurrentThoughtRecord({
  //             thoughtRecordKey: generateThoughtRecordKey(
  //               patientState?.patientId || ""
  //             ),
  //           });
  //         }
  //       } else {
  //         const list = data.result;

  //         list.sort((a, b) => {
  //           return +new Date(b.date || "") - +new Date(a.date || "");
  //         });
  //         setIsEmpty(false);
  //         setHasAiCommentTrkList(
  //           list
  //             .filter((each) => each.hasAiRecommendation)
  //             .map((each) => each.thoughtRecordKey)
  //         );
  //         setListData(list);
  //         let currentIndex = 0;
  //         if (!currentThoughtRecord) {
  //           const incompleteDataIndex = isCoach
  //             ? list.findIndex((element) => element.isHighlight)
  //             : list.findIndex((element) => !element.isDone);
  //           currentIndex = Math.max(incompleteDataIndex, 0);
  //         } else {
  //           currentIndex = list.findIndex(
  //             (element) =>
  //               element.thoughtRecordKey ===
  //               currentThoughtRecord.thoughtRecordKey
  //           );
  //         }
  //         setCurrentThoughtRecord(list[currentIndex]);
  //       }
  //     },
  //   }
  // );

  return (
    <Box
      sx={{
        flexShrink: 0,
        width: isTaskContainerSmall ? "64px" : "300px",
        transition: "transform 0.4s, width 0.4s",
        scrollPaddingBlockStart: "20px",
        pl: isTaskContainerSmall ? "16px" : "24px",
        // pr: "8px",
        mr: "2px",
        height: "100%",
        overflow: "hidden scroll",
      }}
    >
      <Stack
        justifyContent={"center"}
        sx={{
          width: "100%",
          minHeight: "calc(var(--StickyHeader-height) - 0px)",
          height: "calc(var(--StickyHeader-height) - 0px)",
          backgroundColor: "background.level1",
          zIndex: 10,
          position: "sticky",
          top: 0,
          borderBottom: 1,
          borderColor: "background.level3",
          mb: "20px",
        }}
      >
        <AddNewThoughtRecordButton
          setCurrentThoughtRecord={setCurrentThoughtRecord}
          disabled={
            !(!isCoach && listData?.every((element) => element.lastDoneAt))
          }
        />
      </Stack>
      {/* {isDev && (
        <ThoughtRecordFilter
          filterList={filterList}
          selectedFilterList={selectedFilterList}
          setSelectedFilterList={setSelectedFilterList}
        />
      )} */}
      <List
        sx={{
          pt: "12px",
          "--ListItem-paddingY": 0,
          "--ListItem-paddingX": 0,
        }}
      >
        {listData?.map((thoughtRecord, index) => {
          return (
            <ThoughtRecordListItem
              key={thoughtRecord.thoughtRecordKey}
              isFirstRecordOfMonth={
                index === 0 ||
                (index - 1 >= 0 &&
                  dayjs(listData[index - 1].date).get("month") !==
                    dayjs(listData[index].date).get("month"))
              }
              thoughtRecord={thoughtRecord}
              isSelected={
                currentThoughtRecord?.thoughtRecordKey ===
                thoughtRecord.thoughtRecordKey
              }
              setCurrentThoughtRecord={setCurrentThoughtRecord}
              shouldBeDone={!isCoach && thoughtRecord.shouldBeDone}
            />
          );
        })}
      </List>
    </Box>
  );
}
